import React from "react";
import "./Footer.scss";

export default function Footer() {
  return (
    <div
      style={{
        backgroundColor: "#E4E4E4",
        textAlign: "center",
        padding: "1rem",
      }}
    >
      Copyright © 2025 Tiger Fintech Private Limited
    </div>
  );
}

// =========================================

// import React from "react";
// import { Link } from "react-router-dom";

// import { CiFacebook } from "react-icons/ci";
// import { CiLinkedin } from "react-icons/ci";
// import { FaXTwitter } from "react-icons/fa6";
// import { CiInstagram } from "react-icons/ci";
// import { MdOutlinePhone } from "react-icons/md";

// import "./Footer.scss";

// export default function Footer() {
//   return (
//     <footer style={{ backgroundColor: "#E4E4E4" }}>
//       <div
//         style={{
//           maxWidth: "1240px",
//           margin: "auto",
//           padding: "3rem 1rem",
//         }}
//       >
//         <div className="footer_main">
//           {/* CONTACT US======  */}
//           <div
//             style={{
//               display: "flex",
//               flexDirection: "column",
//               gap: "1rem",
//             }}
//           >
//             <h4
//               style={{ fontSize: "1rem", fontWeight: "700", color: "#383434" }}
//             >
//               Contact Us
//             </h4>

//             <div style={{ color: "#4E4949" }}>
//               <strong>Head Office:</strong> Mezzanine Floor, Bajaj House, 97,
//               Nehru Place, New Delhi-110019
//             </div>

//             <div style={{ color: "#4E4949" }}>
//               <strong>Phone:</strong> {/* <MdOutlinePhone size={20} /> */}
//               <Link
//                 to="tel:1800-313-123123"
//                 target="_blank"
//                 style={{ color: "#4E4949" }}
//                 rel="noreferrer"
//               >
//                 1800-313-123123
//               </Link>
//               <p>Mon - Sat (10 AM - 6 PM)</p>
//             </div>

//             <p style={{ fontSize: "0.9rem" }}>
//               In case of any queries, feel free to call or write to us. We will
//               be very happy to assist you.
//             </p>

//             <div style={{ color: "#4E4949" }}>
//               <strong>Email:</strong>{" "}
//               <Link
//                 to="mailto:contactus@bajajcapital.com"
//                 target="_blank"
//                 style={{ color: "#4E4949" }}
//                 rel="noreferrer"
//               >
//                 contactus@bajajcapital.com
//               </Link>
//             </div>

//             <div style={{ display: "flex", gap: "1rem" }}>
//               <Link
//                 to="https://www.facebook.com/bajajcapital"
//                 target="_blank"
//                 style={{ cursor: "pointer" }}
//               >
//                 <svg
//                   width="24"
//                   height="24"
//                   viewBox="0 0 24 24"
//                   xmlns="http://www.w3.org/2000/svg"
//                 >
//                   <rect width="24" height="24" rx="4" fill="#1877F2" />
//                   <path
//                     d="M15.12 12l.38-2.48h-2.33V8c0-.68.33-1.33 1.4-1.33h1.09V4.16s-.98-.17-1.91-.17c-1.95 0-3.22 1.18-3.22 3.32V9.5h-2.15V12h2.15v6.5h2.66V12h1.95z"
//                     fill="white"
//                   />
//                 </svg>
//               </Link>

//               {/* TWITTER=====  */}
//               <Link
//                 to="https://twitter.com/mybajajcapital"
//                 target="_blank"
//                 style={{ cursor: "pointer" }}
//               >
//                 <svg
//                   width="24"
//                   height="24"
//                   viewBox="0 0 24 24"
//                   xmlns="http://www.w3.org/2000/svg"
//                 >
//                   <rect width="24" height="24" rx="4" fill="black" />
//                   <path
//                     d="M16.5 6h-2.2l-2.8 4.3L8.5 6H6.2l3.8 6-3.7 5.5h2.3l2.9-4.5 2.9 4.5h2.3L12.7 12l3.8-6z"
//                     fill="white"
//                   />
//                 </svg>
//               </Link>

//               {/* linkedIN===== */}
//               <Link
//                 to="https://www.linkedin.com/company/bajaj-capital-ltd"
//                 target="_blank"
//                 style={{ cursor: "pointer" }}
//               >
//                 <svg
//                   width="24"
//                   height="24"
//                   viewBox="0 0 24 24"
//                   xmlns="http://www.w3.org/2000/svg"
//                 >
//                   <rect width="24" height="24" rx="4" fill="#0077B5" />
//                   <path
//                     d="M7.6 6.5c0 .9-.7 1.6-1.6 1.6-.9 0-1.6-.7-1.6-1.6S5.1 5 6 5s1.6.7 1.6 1.5zm-2.9 2.3h2.6v9.7H4.7V8.8zm4.6 0h2.5v1.3h.1c.3-.6 1.1-1.2 2.2-1.2 2.3 0 2.8 1.5 2.8 3.4v5.2h-2.6v-4.6c0-1.1 0-2.4-1.5-2.4s-1.7 1.2-1.7 2.3v4.7H9.3V8.8z"
//                     fill="white"
//                   />
//                 </svg>
//               </Link>

//               {/* instagram=====  */}
//               <Link
//                 to="https://instagram.com/bajaj_capital"
//                 target="_blank"
//                 style={{ cursor: "pointer" }}
//               >
//                 <svg
//                   width="24"
//                   height="24"
//                   viewBox="0 0 24 24"
//                   xmlns="http://www.w3.org/2000/svg"
//                 >
//                   <defs>
//                     <linearGradient
//                       id="instaGradient"
//                       x1="0"
//                       y1="0"
//                       x2="1"
//                       y2="1"
//                     >
//                       <stop offset="0%" stopColor="#f9ce34" />
//                       <stop offset="50%" stopColor="#ee2a7b" />
//                       <stop offset="100%" stopColor="#6228d7" />
//                     </linearGradient>
//                   </defs>
//                   <rect
//                     width="24"
//                     height="24"
//                     rx="4"
//                     fill="url(#instaGradient)"
//                   />
//                   <path
//                     d="M12 7.2c-2.6 0-4.8 2.1-4.8 4.8s2.1 4.8 4.8 4.8 4.8-2.1 4.8-4.8-2.1-4.8-4.8-4.8zm0 7.8c-1.7 0-3-1.3-3-3s1.3-3 3-3 3 1.3 3 3-1.3 3-3 3zm4.7-6.8c.3 0 .5-.1.7-.3s.3-.4.3-.7-.1-.5-.3-.7c-.2-.2-.4-.3-.7-.3s-.5.1-.7.3c-.2.2-.3.4-.3.7s.1.5.3.7c.2.2.4.3.7.3zm2.4 1c-.1-1.4-.4-2.4-1-3.2s-1.8-1.1-3.2-1.2c-1.4-.1-5.6-.1-7 0-1.4.1-2.5.4-3.2 1.2s-1 1.8-1 3.2c-.1 1.4-.1 5.6 0 7 0 1.4.4 2.5 1.2 3.2s1.8 1 3.2 1.1c1.4.1 5.6.1 7 0 1.4-.1 2.5-.4 3.2-1.1s1-1.8 1.1-3.2c.1-1.4.1-5.6 0-7zm-1.8 8.5c-.3.7-.9 1.2-1.7 1.4-1.2.3-3.9.2-5.2.2s-4 .1-5.2-.2c-.8-.2-1.4-.7-1.7-1.4-.3-1.2-.2-3.9-.2-5.2s-.1-4 .2-5.2c.2-.8.9-1.4 1.7-1.7 1.2-.3 3.9-.2 5.2-.2s4-.1 5.2.2c.8.2 1.4.9 1.7 1.7.3 1.2.2 3.9.2 5.2s.1 4-.2 5.2z"
//                     fill="white"
//                   />
//                 </svg>
//               </Link>

//               {/* YT======  */}
//               <Link
//                 to="https://www.youtube.com/channel/UCHd387ggvz3JC7I9wVtPhtw"
//                 target="_blank"
//                 style={{ cursor: "pointer" }}
//               >
//                 <svg
//                   width="24"
//                   height="24"
//                   viewBox="0 0 24 24"
//                   xmlns="http://www.w3.org/2000/svg"
//                 >
//                   <rect width="24" height="24" rx="4" fill="#FF0000" />
//                   <path
//                     d="M10 15l5.5-3-5.5-3v6zm-4-9h12c1.7 0 3 1.3 3 3v6c0 1.7-1.3 3-3 3H6c-1.7 0-3-1.3-3-3V9c0-1.7 1.3-3 3-3z"
//                     fill="white"
//                   />
//                 </svg>
//               </Link>
//             </div>
//           </div>
//         </div>
//       </div>
//       {/* ====COPYRIGHT====== */}
//       <div style={{ borderTop: "1px solid #4E4949" }}>
//         <div
//           className="copyright_section"
//           style={{
//             maxWidth: "1240px",
//             margin: "auto",
//             textAlign: "center",
//             fontSize: "1rem",
//             color: "#4E4949",
//             padding: "1.5rem",
//             display: "flex",
//             justifyContent: "space-between",
//             alignItems: "center",
//           }}
//         >
//           <div>
//             Copyright © {new Date().getFullYear()}{" "}
//             <Link
//               to="https://www.bajajcapital.com/"
//               style={{ fontWeight: "700", color: "#4E4949" }}
//             >
//               BajajCapital Limited
//             </Link>
//           </div>
//           <div style={{ display: "flex", gap: "0.5rem", alignItems: "center" }}>
//             <Link to="https://www.bajajcapital.com/term-conditions?doc=legal_disclaimer">
//               Legal Disclaimer
//             </Link>
//             <div
//               style={{ borderLeft: "2px solid black", height: "20px" }}
//             ></div>
//             <Link to="https://www.bajajcapital.com/term-conditions?doc=privacy_policy">
//               Privacy Policy
//             </Link>
//             {/* <Link to="privacy-policy">Privacy Policy</Link> */}
//             <div
//               style={{ borderLeft: "2px solid black", height: "20px" }}
//             ></div>
//             <Link to="https://www.bajajcapital.com/term-conditions?doc=tnc">
//               Terms and Conditions
//             </Link>
//             {/* <Link to="terms-conditions">Terms and Conditions</Link> */}
//           </div>
//         </div>
//       </div>
//     </footer>
//   );
// }

// =========================================

// export default function Footer() {
//   return (
//     <footer style={{ backgroundColor: "#E4E4E4" }}>
//       <div
//         style={{
//           maxWidth: "1240px",
//           margin: "auto",
//           padding: "2rem 1rem",
//         }}
//       >
//         <div className="footer_main">
//           <div className="footer_logo">
//             <p>
//               BajajCapital is India’s premier investment services group engaged
//               inter-alia in the distribution of mutual funds, insurance, fixed
//               deposits, bonds, loans et al.
//             </p>

//             {/* =========================================================================  */}
//             <div>
//               <div style={{ display: "inline-block", textAlign: "center" }}>
//                 <div className="social_icons_main">
//                   <h4 className="follow_us_heading">Follow us on</h4>
//                   <div className="social-links">
//                     <Link
//                       to="https://www.instagram.com/batukify/"
//                       target="_blank"
//                       className="social-link"
//                     >
//                       <CiInstagram size={32} color="#383434" />
//                     </Link>
//                     <Link
//                       to="https://www.facebook.com/people/Batuk-App/61567131733842/?sk=photos"
//                       target="_blank"
//                       className="social-link"
//                     >
//                       <CiFacebook size={32} color="#383434" />
//                     </Link>
//                     <Link
//                       to="https://www.linkedin.com/company/bharat-batuk-private-limited/posts/?feedView=all"
//                       target="_blank"
//                       className="social-link"
//                     >
//                       <CiLinkedin size={32} color="#383434" />
//                     </Link>
//                     <Link
//                       to="https://x.com/Batukify"
//                       target="_blank"
//                       className="social-link"
//                     >
//                       <FaXTwitter size={30} color="#383434" />
//                     </Link>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//           {/* CONTACT US======  */}
//           <div
//             style={{
//               display: "flex",
//               flexDirection: "column",
//               gap: "1rem",
//             }}
//           >
//             <h4
//               style={{ fontSize: "1rem", fontWeight: "700", color: "#383434" }}
//             >
//               Contact Us
//             </h4>
//             <p style={{ fontSize: "0.9rem" }}>
//               In case of any queries, feel free to call or write to us. We will
//               be very happy to assist you.
//             </p>

//             <span style={{ color: "#4E4949" }}>
//               <strong>Phone:</strong>{" "}
//               <Link
//                 href="tel:1800-313-123123"
//                 target="_blank"
//                 style={{ textDecoration: "underline", color: "#4E4949" }}
//                 className="footer_link"
//                 rel="noreferrer"
//               >
//                 1800-313-123123
//               </Link>
//             </span>

//             <span style={{ color: "#4E4949" }}>
//               <strong>Email:</strong>{" "}
//               <Link
//                 href="mailto:contactus@bajajcapital.com"
//                 target="_blank"
//                 style={{ textDecoration: "underline", color: "#4E4949" }}
//                 className="footer_link"
//                 rel="noreferrer"
//               >
//                 contactus@bajajcapital.com
//               </Link>
//             </span>
//           </div>
//           {/* EXPLORE=========  */}
//           <div
//             style={{
//               display: "flex",
//               flexDirection: "column",
//               gap: "1rem",
//             }}
//           >
//             <h4
//               style={{ fontSize: "1rem", fontWeight: "700", color: "#383434" }}
//             >
//               Explore
//             </h4>
//             <Link to="/">
//               <span className="animated-link">Home</span>
//             </Link>
//             {/* <Link to="/about-us" onClick={scrollToTop}>
//               <span className="animated-link">About Us</span>
//             </Link> */}
//             <Link to="/contact-us" onClick={scrollToTop}>
//               <span className="animated-link">Contact Us</span>
//             </Link>
//             {/* <Link to="/blogs">
//               <span className="animated-link">Blogs</span>
//             </Link> */}
//           </div>
//           {/* RESOURSE==========  */}
//           <div
//             style={{
//               display: "flex",
//               flexDirection: "column",
//               gap: "1rem",
//             }}
//           >
//             <h4
//               style={{ fontSize: "1rem", fontWeight: "700", color: "#383434" }}
//             >
//               Resourse
//             </h4>
//             <Link to="/faqs">
//               <span className="animated-link">FAQ</span>
//             </Link>

//             <Link to="/shipping-policy">
//               <span className="animated-link">Shipping Policy</span>
//             </Link>
//             <Link to="/refund-policy">
//               <span className="animated-link">Refund Policy</span>
//             </Link>
//             <Link to="/terms-conditions">
//               <span className="animated-link">Terms & Conditions</span>
//             </Link>
//             <Link to="/privacy-policy">
//               <span className="animated-link">Privacy Policy</span>
//             </Link>
//           </div>
//         </div>
//       </div>
//       {/* COPYRIGHT============== */}
//       <div
//         style={{
//           textAlign: "center",
//           borderTop: "1px solid #4E4949",
//           fontSize: "1rem",
//           color: "#4E4949",
//           padding: "1.5rem",
//         }}
//       >
//         © Copyright {new Date().getFullYear()}{" "}
//         <Link to="/" style={{ fontWeight: "700", color: "#4E4949" }}>
//           {" "}
//           Bharat Batuk Private Limited{" "}
//         </Link>
//         All rights reserved.
//       </div>
//     </footer>
//   );
// }

// import React from "react";
// import { Link } from "react-router-dom";

// import { CiFacebook } from "react-icons/ci";
// import { CiLinkedin } from "react-icons/ci";
// import { FaXTwitter } from "react-icons/fa6";
// import { CiInstagram } from "react-icons/ci";
// import { MdOutlinePhone } from "react-icons/md";

// import "./Footer.scss";

// export default function Footer() {
//   return (
//     <footer style={{ backgroundColor: "#E4E4E4" }}>
//       <div
//         style={{
//           maxWidth: "1240px",
//           margin: "auto",
//           padding: "3rem 1rem",
//         }}
//       >
//         <div className="footer_main">
//           {/* =======  */}
//           <div className="footer_logo">
//             <Link to="https://www.bajajcapital.com/">
//               <img
//                 src="/images/BajajLogo.png"
//                 alt="Bajaj_logo"
//                 className="nav_main_logo"
//               />
//             </Link>
//             <p>
//               BajajCapital is India’s premier investment services group engaged
//               inter-alia in the distribution of mutual funds, insurance, fixed
//               deposits, bonds, loans et al.
//             </p>

//             {/* =====SOCIAL LINKS======  */}
//             {/* <div>
//               <div style={{ display: "inline-block", textAlign: "center" }}>
//                 <div className="social_icons_main">
//                   <h4 className="follow_us_heading">Follow us on</h4>
//                   <div className="social-links">
//                     <Link
//                       to="https://www.instagram.com/batukify/"
//                       target="_blank"
//                       className="social-link"
//                     >
//                       <CiInstagram size={32} color="#383434" />
//                     </Link>
//                     <Link
//                       to="https://www.facebook.com/people/Batuk-App/61567131733842/?sk=photos"
//                       target="_blank"
//                       className="social-link"
//                     >
//                       <CiFacebook size={32} color="#383434" />
//                     </Link>
//                     <Link
//                       to="https://www.linkedin.com/company/bharat-batuk-private-limited/posts/?feedView=all"
//                       target="_blank"
//                       className="social-link"
//                     >
//                       <CiLinkedin size={32} color="#383434" />
//                     </Link>
//                     <Link
//                       to="https://x.com/Batukify"
//                       target="_blank"
//                       className="social-link"
//                     >
//                       <FaXTwitter size={30} color="#383434" />
//                     </Link>
//                   </div>
//                 </div>
//               </div>
//             </div> */}
//           </div>
//           {/* ====OFFERING=====  */}
//           <div
//             style={{
//               display: "flex",
//               flexDirection: "column",
//               gap: "1rem",
//             }}
//           >
//             <h4
//               style={{ fontSize: "1rem", fontWeight: "700", color: "#383434" }}
//             >
//               Offering
//             </h4>

//             <ul
//               style={{
//                 listStyle: "none",
//                 padding: 0,
//                 margin: 0,
//                 display: "flex",
//                 flexDirection: "column",
//                 gap: "1rem",
//                 fontSize: "0.9rem",
//               }}
//             >
//               {/* <span>Digital Gold</span>
//               <span>Digital Silver</span> */}
//               <li>
//                 <Link to="https://onlinemf.bajajcapital.com/" target="_blank">
//                   Mutual Funds
//                 </Link>
//               </li>
//               <li>
//                 <Link
//                   to="https://www.bajajcapitalinsurance.com/"
//                   target="_blank"
//                 >
//                   Insurance
//                 </Link>
//               </li>
//               <li>
//                 <Link to="https://nps.bajajcapital.com/" target="_blank">
//                   National Pension System
//                 </Link>
//               </li>
//               <li>
//                 <Link
//                   to="https://www.bajajcapitalinsurance.com/general-insurance/health/input/basic-details"
//                   target="_blank"
//                 >
//                   Health Insurance
//                 </Link>
//               </li>
//               <li>
//                 <Link
//                   to="https://www.bajajcapitalinsurance.com/general-insurance/car/lead-page"
//                   target="_blank"
//                 >
//                   Car Insurance
//                 </Link>
//               </li>
//               <li>
//                 <Link
//                   to="https://www.bajajcapitalinsurance.com/general-insurance/bike/lead-page"
//                   target="_blank"
//                 >
//                   Two-Wheeler Insurance
//                 </Link>
//               </li>
//               <li>
//                 <Link
//                   to="https://www.bajajcapitalinsurance.com/general-insurance/pet/input/customer-details"
//                   target="_blank"
//                 >
//                   Pet Insurance
//                 </Link>
//               </li>
//               <li>
//                 <Link to="https://www.bajajcapital.com/bonds">Bonds</Link>
//               </li>
//               <li>
//                 <Link to="https://fd.bajajcapital.com/" target="_blank">
//                   Fixed Deposits
//                 </Link>
//               </li>
//               <li>
//                 <Link
//                   to="https://www.bajajcapital.com/beautiful-minds"
//                   target=""
//                 >
//                   Exclusively for Women
//                 </Link>
//               </li>
//               <li>
//                 <Link
//                   to="https://www.bajajcapital.com/mutual-fund/mf-amc"
//                   target=""
//                 >
//                   AMC for Investments
//                 </Link>
//               </li>
//               <li>
//                 <Link
//                   to="https://pos.bajajcapitalinsurance.com/"
//                   target="_blank"
//                 >
//                   Partner With Us
//                 </Link>
//               </li>
//               <li>
//                 <Link to="https://www.bajajcapitalsec.com/" target="_blank">
//                   Investment Banking
//                 </Link>
//               </li>
//               <li>
//                 <Link
//                   to="https://loan.bajajcapital.com/loan-against-securities"
//                   target="_blank"
//                 >
//                   Loan Against Securities
//                 </Link>
//               </li>
//               <li>
//                 <Link
//                   to="https://renew-all.bajajcapitalinsurance.com/"
//                   target="_blank"
//                 >
//                   All Renewals
//                 </Link>
//               </li>
//               <li>
//                 <Link to="https://start.bajajcapital.com/gpw/" target="_blank">
//                   Global Private Wealth
//                 </Link>
//               </li>
//               <li>
//                 <Link
//                   to="https://start.bajajcapital.com/wealthmax/"
//                   target="_blank"
//                 >
//                   Portfolio Analytics
//                 </Link>
//               </li>
//               <li>
//                 <Link
//                   to="https://www.bajajcapital.com/tigercreditcard?utm_source=Website&amp;utm_medium=Footer"
//                   target=""
//                 >
//                   Tiger Credit Card
//                 </Link>
//               </li>
//             </ul>
//           </div>
//           {/* ====Calculators=====  */}
//           <div
//             style={{
//               display: "flex",
//               flexDirection: "column",
//               gap: "1rem",
//             }}
//           >
//             <h4
//               style={{ fontSize: "1rem", fontWeight: "700", color: "#383434" }}
//             >
//               Calculators
//             </h4>

//             <ul
//               style={{
//                 listStyle: "none",
//                 padding: 0,
//                 margin: 0,
//                 display: "flex",
//                 flexDirection: "column",
//                 gap: "1rem",
//                 fontSize: "0.9rem",
//               }}
//             >
//               <li>
//                 <Link
//                   to="https://www.bajajcapital.com/financial-calculators/sip-planner"
//                   target=""
//                 >
//                   Systematic Investment Planner
//                 </Link>
//               </li>
//               <li>
//                 <Link
//                   to="https://www.bajajcapital.com/financial-calculators/lumpsum-calculator"
//                   target=""
//                 >
//                   Lumpsum Investment
//                 </Link>
//               </li>
//               <li>
//                 <Link
//                   to="https://www.bajajcapital.com/financial-calculators/swp-calculator"
//                   target=""
//                 >
//                   Systematic Withdrawal Planner
//                 </Link>
//               </li>
//               <li>
//                 <Link
//                   to="https://nps.bajajcapital.com/#EMICalculator"
//                   target="_blank"
//                 >
//                   Pension
//                 </Link>
//               </li>
//               <li>
//                 <Link
//                   to="https://www.bajajcapital.com/financial-calculators/marriage-planner-calculator"
//                   target=""
//                 >
//                   Child's Marriage Planner
//                 </Link>
//               </li>
//               <li>
//                 <Link
//                   to="https://www.bajajcapital.com/financial-calculators/maturity-calculator"
//                   target=""
//                 >
//                   Maturity Amount
//                 </Link>
//               </li>
//               <li>
//                 <Link
//                   to="https://www.bajajcapital.com/financial-calculators/human-life-value-calculator"
//                   target=""
//                 >
//                   Human Life Value
//                 </Link>
//               </li>
//               <li>
//                 <Link
//                   to="https://www.bajajcapital.com/financial-calculators/gratuity-calculator"
//                   target=""
//                 >
//                   Gratuity
//                 </Link>
//               </li>
//               <li>
//                 <Link to="https://www.bajajcapital.com/tax-saving-solutions">
//                   Tax Saving
//                 </Link>
//               </li>
//               <li>
//                 <Link
//                   to="https://www.bajajcapital.com/retirement-planning"
//                   target=""
//                 >
//                   Retirement Planning
//                 </Link>
//               </li>
//               <li>
//                 <Link
//                   to="https://www.bajajcapital.com/financial-calculators/crorepati-calculator"
//                   target=""
//                 >
//                   Crorepati Calculator
//                 </Link>
//               </li>
//               <li>
//                 <Link
//                   to="https://www.bajajcapital.com/retirement/readytoretirescore"
//                   target=""
//                 >
//                   Ready to Retire Score
//                 </Link>
//               </li>
//               <li>
//                 <Link
//                   to="https://www.bajajcapital.com/retirement/preparedness"
//                   target=""
//                 >
//                   Preparedness
//                 </Link>
//               </li>
//             </ul>
//           </div>
//           {/* ====Resources=======  */}
//           <div
//             style={{
//               display: "flex",
//               flexDirection: "column",
//               gap: "1rem",
//             }}
//           >
//             <h4
//               style={{ fontSize: "1rem", fontWeight: "700", color: "#383434" }}
//             >
//               Resources
//             </h4>
//             <ul
//               style={{
//                 listStyle: "none",
//                 padding: 0,
//                 margin: 0,
//                 display: "flex",
//                 flexDirection: "column",
//                 gap: "1rem",
//                 fontSize: "0.9rem",
//               }}
//             >
//               <li>
//                 <Link to="https://www.bajajcapital.com/about-us">About Us</Link>
//               </li>
//               <li>
//                 <Link
//                   to="https://www.bajajcapital.com/our-new-identity.html"
//                   target=""
//                 >
//                   New Brand Identity
//                 </Link>
//               </li>
//               <li>
//                 <Link
//                   to="https://www.bajajcapital.com/about-us/ceo-bajaj-capital-insurance"
//                   target=""
//                 >
//                   CEO BajajCapital Insurance
//                 </Link>
//               </li>
//               <li>
//                 <Link
//                   to="https://www.bajajcapital.com/about-us/deputy-ceo-wealth-bajaj-capital"
//                   target=""
//                 >
//                   Deputy CEO - Wealth
//                 </Link>
//               </li>
//               <li>
//                 <Link to="https://www.bajajcapital.com/rm-assistance">
//                   RM Assistance
//                 </Link>
//               </li>
//               <li>
//                 <Link to="https://www.bajajcapital.com/help-centre#branch">
//                   Branch Locator
//                 </Link>
//               </li>
//               <li>
//                 <Link to="https://www.bajajcapital.com/careers">Careers</Link>
//               </li>
//               <li>
//                 <Link to="https://www.bajajcapital.com/customer-reviews">
//                   Customer Testimonials
//                 </Link>
//               </li>
//               <li>
//                 <Link to="https://www.bajajcapital.com/help-centre">
//                   Help Centre
//                 </Link>
//               </li>
//               <li>
//                 <Link to="https://www.bajajcapital.com/blog">Blog</Link>
//               </li>
//               <li>
//                 <Link
//                   to="https://www.bajajcapital.com/dpservices/dp-service"
//                   target=""
//                 >
//                   DP Services
//                 </Link>
//               </li>
//               <li>
//                 <Link
//                   to="https://www.bajajcapital.com/privacy/vigil-mechanism-policy"
//                   target=""
//                 >
//                   Important Policies
//                 </Link>
//               </li>
//               <li>
//                 <Link
//                   to="https://www.bajajcapital.com/assets/social-media-policy.pdf"
//                   target=""
//                 >
//                   Other Policies
//                 </Link>
//               </li>
//               <li>
//                 <Link
//                   to="https://www.bajajcapital.com/research/knowledge-series"
//                   target=""
//                 >
//                   Information Centre
//                 </Link>
//               </li>
//               <li>
//                 <Link
//                   to="https://www.bajajcapital.com/publication-archive"
//                   target=""
//                 >
//                   Publications
//                 </Link>
//               </li>
//               <li>
//                 <Link
//                   to="https://digital.bajajcapital.com/employee-verse/login"
//                   target="_blank"
//                 >
//                   For Employee
//                 </Link>
//               </li>
//             </ul>
//           </div>
//           {/* EXPLORE=========  */}
//           {/* <div
//             style={{
//               display: "flex",
//               flexDirection: "column",
//               gap: "1rem",
//             }}
//           >
//             <h4
//               style={{ fontSize: "1rem", fontWeight: "700", color: "#383434" }}
//             >
//               Explore
//             </h4>
//             <Link to="/">
//               <span className="animated-link">Home</span>
//             </Link>
//             <Link to="/contact-us">
//               <span className="animated-link">Contact Us</span>
//             </Link>
//           </div> */}
//           {/* ===Batuk RESOURSE========  */}
//           {/* <div
//             style={{
//               display: "flex",
//               flexDirection: "column",
//               gap: "1rem",
//             }}
//           >
//             <h4
//               style={{ fontSize: "1rem", fontWeight: "700", color: "#383434" }}
//             >
//               Resourse
//             </h4>
//             <Link to="/faqs">
//               <span className="animated-link">FAQ</span>
//             </Link>

//             <Link to="/shipping-policy">
//               <span className="animated-link">Shipping Policy</span>
//             </Link>
//             <Link to="/refund-policy">
//               <span className="animated-link">Refund Policy</span>
//             </Link>
//             <Link to="/terms-conditions">
//               <span className="animated-link">Terms & Conditions</span>
//             </Link>
//             <Link to="/privacy-policy">
//               <span className="animated-link">Privacy Policy</span>
//             </Link>
//           </div> */}
//           {/* ====NEW Resources=======  */}
//           {/* <div
//             style={{
//               display: "flex",
//               flexDirection: "column",
//               gap: "1rem",
//             }}
//           >
//             <h4
//               style={{ fontSize: "1rem", fontWeight: "700", color: "#383434" }}
//             >
//               Resources
//             </h4>
//             <ul
//               style={{
//                 listStyle: "none",
//                 padding: 0,
//                 margin: 0,
//                 display: "flex",
//                 flexDirection: "column",
//                 gap: "1rem",
//                 fontSize: "0.9rem",
//               }}
//             >
//               <li>
//                 <Link to="refund-policy">Refund Policy</Link>
//               </li>
//               <li>
//                 <Link to="shipping-policy">Shipping Policy</Link>
//               </li>
//               <li>
//                 <Link to="cancellation-policy">Cancellation Policy</Link>
//               </li>
//             </ul>
//           </div> */}
//           {/* CONTACT US======  */}
//           <div
//             style={{
//               display: "flex",
//               flexDirection: "column",
//               gap: "1rem",
//             }}
//           >
//             <h4
//               style={{ fontSize: "1rem", fontWeight: "700", color: "#383434" }}
//             >
//               Contact Us
//             </h4>

//             <div>
//               <strong>Head Office:</strong> Mezzanine Floor, Bajaj House, 97,
//               Nehru Place, New Delhi-110019
//             </div>

//             <span style={{ color: "#4E4949" }}>
//               <strong>Phone:</strong>{" "}
//               {/* <MdOutlinePhone size={20} /> */}
//               <Link
//                 to="tel:1800-313-123123"
//                 target="_blank"
//                 style={{ color: "#4E4949" }}
//                 rel="noreferrer"
//               >
//                 1800-313-123123
//               </Link>
//               <p>Mon - Sat (10 AM - 6 PM)</p>
//             </span>

//             <p style={{ fontSize: "0.9rem" }}>
//               In case of any queries, feel free to call or write to us. We will
//               be very happy to assist you.
//             </p>

//             <span style={{ color: "#4E4949" }}>
//               {/* <strong>Email:</strong>{" "} */}
//               <Link
//                 to="mailto:contactus@bajajcapital.com"
//                 target="_blank"
//                 style={{ color: "#4E4949" }}
//                 rel="noreferrer"
//               >
//                 contactus@bajajcapital.com
//               </Link>
//             </span>

//             <div style={{ display: "flex", gap: "1rem" }}>
//               <Link
//                 to="https://www.facebook.com/bajajcapital"
//                 target="_blank"
//                 style={{ cursor: "pointer" }}
//               >
//                 <svg
//                   width="24"
//                   height="24"
//                   viewBox="0 0 24 24"
//                   xmlns="http://www.w3.org/2000/svg"
//                 >
//                   <rect width="24" height="24" rx="4" fill="#1877F2" />
//                   <path
//                     d="M15.12 12l.38-2.48h-2.33V8c0-.68.33-1.33 1.4-1.33h1.09V4.16s-.98-.17-1.91-.17c-1.95 0-3.22 1.18-3.22 3.32V9.5h-2.15V12h2.15v6.5h2.66V12h1.95z"
//                     fill="white"
//                   />
//                 </svg>
//               </Link>

//               {/* TWITTER=====  */}
//               <Link
//                 to="https://twitter.com/mybajajcapital"
//                 target="_blank"
//                 style={{ cursor: "pointer" }}
//               >
//                 <svg
//                   width="24"
//                   height="24"
//                   viewBox="0 0 24 24"
//                   xmlns="http://www.w3.org/2000/svg"
//                 >
//                   <rect width="24" height="24" rx="4" fill="black" />
//                   <path
//                     d="M16.5 6h-2.2l-2.8 4.3L8.5 6H6.2l3.8 6-3.7 5.5h2.3l2.9-4.5 2.9 4.5h2.3L12.7 12l3.8-6z"
//                     fill="white"
//                   />
//                 </svg>
//               </Link>

//               {/* linkedIN===== */}
//               <Link
//                 to="https://www.linkedin.com/company/bajaj-capital-ltd"
//                 target="_blank"
//                 style={{ cursor: "pointer" }}
//               >
//                 <svg
//                   width="24"
//                   height="24"
//                   viewBox="0 0 24 24"
//                   xmlns="http://www.w3.org/2000/svg"
//                 >
//                   <rect width="24" height="24" rx="4" fill="#0077B5" />
//                   <path
//                     d="M7.6 6.5c0 .9-.7 1.6-1.6 1.6-.9 0-1.6-.7-1.6-1.6S5.1 5 6 5s1.6.7 1.6 1.5zm-2.9 2.3h2.6v9.7H4.7V8.8zm4.6 0h2.5v1.3h.1c.3-.6 1.1-1.2 2.2-1.2 2.3 0 2.8 1.5 2.8 3.4v5.2h-2.6v-4.6c0-1.1 0-2.4-1.5-2.4s-1.7 1.2-1.7 2.3v4.7H9.3V8.8z"
//                     fill="white"
//                   />
//                 </svg>
//               </Link>

//               {/* instagram=====  */}
//               <Link
//                 to="https://instagram.com/bajaj_capital"
//                 target="_blank"
//                 style={{ cursor: "pointer" }}
//               >
//                 <svg
//                   width="24"
//                   height="24"
//                   viewBox="0 0 24 24"
//                   xmlns="http://www.w3.org/2000/svg"
//                 >
//                   <defs>
//                     <linearGradient
//                       id="instaGradient"
//                       x1="0"
//                       y1="0"
//                       x2="1"
//                       y2="1"
//                     >
//                       <stop offset="0%" stopColor="#f9ce34" />
//                       <stop offset="50%" stopColor="#ee2a7b" />
//                       <stop offset="100%" stopColor="#6228d7" />
//                     </linearGradient>
//                   </defs>
//                   <rect
//                     width="24"
//                     height="24"
//                     rx="4"
//                     fill="url(#instaGradient)"
//                   />
//                   <path
//                     d="M12 7.2c-2.6 0-4.8 2.1-4.8 4.8s2.1 4.8 4.8 4.8 4.8-2.1 4.8-4.8-2.1-4.8-4.8-4.8zm0 7.8c-1.7 0-3-1.3-3-3s1.3-3 3-3 3 1.3 3 3-1.3 3-3 3zm4.7-6.8c.3 0 .5-.1.7-.3s.3-.4.3-.7-.1-.5-.3-.7c-.2-.2-.4-.3-.7-.3s-.5.1-.7.3c-.2.2-.3.4-.3.7s.1.5.3.7c.2.2.4.3.7.3zm2.4 1c-.1-1.4-.4-2.4-1-3.2s-1.8-1.1-3.2-1.2c-1.4-.1-5.6-.1-7 0-1.4.1-2.5.4-3.2 1.2s-1 1.8-1 3.2c-.1 1.4-.1 5.6 0 7 0 1.4.4 2.5 1.2 3.2s1.8 1 3.2 1.1c1.4.1 5.6.1 7 0 1.4-.1 2.5-.4 3.2-1.1s1-1.8 1.1-3.2c.1-1.4.1-5.6 0-7zm-1.8 8.5c-.3.7-.9 1.2-1.7 1.4-1.2.3-3.9.2-5.2.2s-4 .1-5.2-.2c-.8-.2-1.4-.7-1.7-1.4-.3-1.2-.2-3.9-.2-5.2s-.1-4 .2-5.2c.2-.8.9-1.4 1.7-1.7 1.2-.3 3.9-.2 5.2-.2s4-.1 5.2.2c.8.2 1.4.9 1.7 1.7.3 1.2.2 3.9.2 5.2s.1 4-.2 5.2z"
//                     fill="white"
//                   />
//                 </svg>
//               </Link>

//               {/* YT======  */}
//               <Link
//                 to="https://www.youtube.com/channel/UCHd387ggvz3JC7I9wVtPhtw"
//                 target="_blank"
//                 style={{ cursor: "pointer" }}
//               >
//                 <svg
//                   width="24"
//                   height="24"
//                   viewBox="0 0 24 24"
//                   xmlns="http://www.w3.org/2000/svg"
//                 >
//                   <rect width="24" height="24" rx="4" fill="#FF0000" />
//                   <path
//                     d="M10 15l5.5-3-5.5-3v6zm-4-9h12c1.7 0 3 1.3 3 3v6c0 1.7-1.3 3-3 3H6c-1.7 0-3-1.3-3-3V9c0-1.7 1.3-3 3-3z"
//                     fill="white"
//                   />
//                 </svg>
//               </Link>
//             </div>
//           </div>
//         </div>
//       </div>
//       {/* ====COPYRIGHT====== */}
//       <div style={{ borderTop: "1px solid #4E4949" }}>
//         <div
//           className="copyright_section"
//           style={{
//             maxWidth: "1240px",
//             margin: "auto",
//             textAlign: "center",
//             fontSize: "1rem",
//             color: "#4E4949",
//             padding: "1.5rem",
//             display: "flex",
//             justifyContent: "space-between",
//             alignItems: "center",
//           }}
//         >
//           <div>
//             Copyright © {new Date().getFullYear()}{" "}
//             <Link
//               to="https://www.bajajcapital.com/"
//               style={{ fontWeight: "700", color: "#4E4949" }}
//             >
//               BajajCapital Limited
//             </Link>
//           </div>
//           <div style={{ display: "flex", gap: "0.5rem", alignItems: "center" }}>
//             <Link to="https://www.bajajcapital.com/term-conditions?doc=legal_disclaimer">
//               Legal Disclaimer
//             </Link>
//             <div
//               style={{ borderLeft: "2px solid black", height: "20px" }}
//             ></div>
//             <Link to="https://www.bajajcapital.com/term-conditions?doc=privacy_policy">
//               Privacy Policy
//             </Link>
//             {/* <Link to="privacy-policy">Privacy Policy</Link> */}
//             <div
//               style={{ borderLeft: "2px solid black", height: "20px" }}
//             ></div>
//             <Link to="https://www.bajajcapital.com/term-conditions?doc=tnc">
//               Terms and Conditions
//             </Link>
//             {/* <Link to="terms-conditions">Terms and Conditions</Link> */}
//           </div>
//         </div>
//       </div>
//     </footer>
//   );
// }

// // export default function Footer() {
// //   return (
// //     <footer style={{ backgroundColor: "#E4E4E4" }}>
// //       <div
// //         style={{
// //           maxWidth: "1240px",
// //           margin: "auto",
// //           padding: "2rem 1rem",
// //         }}
// //       >
// //         <div className="footer_main">
// //           <div className="footer_logo">
// //             <p>
// //               BajajCapital is India’s premier investment services group engaged
// //               inter-alia in the distribution of mutual funds, insurance, fixed
// //               deposits, bonds, loans et al.
// //             </p>

// //             {/* =========================================================================  */}
// //             <div>
// //               <div style={{ display: "inline-block", textAlign: "center" }}>
// //                 <div className="social_icons_main">
// //                   <h4 className="follow_us_heading">Follow us on</h4>
// //                   <div className="social-links">
// //                     <Link
// //                       to="https://www.instagram.com/batukify/"
// //                       target="_blank"
// //                       className="social-link"
// //                     >
// //                       <CiInstagram size={32} color="#383434" />
// //                     </Link>
// //                     <Link
// //                       to="https://www.facebook.com/people/Batuk-App/61567131733842/?sk=photos"
// //                       target="_blank"
// //                       className="social-link"
// //                     >
// //                       <CiFacebook size={32} color="#383434" />
// //                     </Link>
// //                     <Link
// //                       to="https://www.linkedin.com/company/bharat-batuk-private-limited/posts/?feedView=all"
// //                       target="_blank"
// //                       className="social-link"
// //                     >
// //                       <CiLinkedin size={32} color="#383434" />
// //                     </Link>
// //                     <Link
// //                       to="https://x.com/Batukify"
// //                       target="_blank"
// //                       className="social-link"
// //                     >
// //                       <FaXTwitter size={30} color="#383434" />
// //                     </Link>
// //                   </div>
// //                 </div>
// //               </div>
// //             </div>
// //           </div>
// //           {/* CONTACT US======  */}
// //           <div
// //             style={{
// //               display: "flex",
// //               flexDirection: "column",
// //               gap: "1rem",
// //             }}
// //           >
// //             <h4
// //               style={{ fontSize: "1rem", fontWeight: "700", color: "#383434" }}
// //             >
// //               Contact Us
// //             </h4>
// //             <p style={{ fontSize: "0.9rem" }}>
// //               In case of any queries, feel free to call or write to us. We will
// //               be very happy to assist you.
// //             </p>

// //             <span style={{ color: "#4E4949" }}>
// //               <strong>Phone:</strong>{" "}
// //               <Link
// //                 href="tel:1800-313-123123"
// //                 target="_blank"
// //                 style={{ textDecoration: "underline", color: "#4E4949" }}
// //                 className="footer_link"
// //                 rel="noreferrer"
// //               >
// //                 1800-313-123123
// //               </Link>
// //             </span>

// //             <span style={{ color: "#4E4949" }}>
// //               <strong>Email:</strong>{" "}
// //               <Link
// //                 href="mailto:contactus@bajajcapital.com"
// //                 target="_blank"
// //                 style={{ textDecoration: "underline", color: "#4E4949" }}
// //                 className="footer_link"
// //                 rel="noreferrer"
// //               >
// //                 contactus@bajajcapital.com
// //               </Link>
// //             </span>
// //           </div>
// //           {/* EXPLORE=========  */}
// //           <div
// //             style={{
// //               display: "flex",
// //               flexDirection: "column",
// //               gap: "1rem",
// //             }}
// //           >
// //             <h4
// //               style={{ fontSize: "1rem", fontWeight: "700", color: "#383434" }}
// //             >
// //               Explore
// //             </h4>
// //             <Link to="/">
// //               <span className="animated-link">Home</span>
// //             </Link>
// //             {/* <Link to="/about-us" onClick={scrollToTop}>
// //               <span className="animated-link">About Us</span>
// //             </Link> */}
// //             <Link to="/contact-us" onClick={scrollToTop}>
// //               <span className="animated-link">Contact Us</span>
// //             </Link>
// //             {/* <Link to="/blogs">
// //               <span className="animated-link">Blogs</span>
// //             </Link> */}
// //           </div>
// //           {/* RESOURSE==========  */}
// //           <div
// //             style={{
// //               display: "flex",
// //               flexDirection: "column",
// //               gap: "1rem",
// //             }}
// //           >
// //             <h4
// //               style={{ fontSize: "1rem", fontWeight: "700", color: "#383434" }}
// //             >
// //               Resourse
// //             </h4>
// //             <Link to="/faqs">
// //               <span className="animated-link">FAQ</span>
// //             </Link>

// //             <Link to="/shipping-policy">
// //               <span className="animated-link">Shipping Policy</span>
// //             </Link>
// //             <Link to="/refund-policy">
// //               <span className="animated-link">Refund Policy</span>
// //             </Link>
// //             <Link to="/terms-conditions">
// //               <span className="animated-link">Terms & Conditions</span>
// //             </Link>
// //             <Link to="/privacy-policy">
// //               <span className="animated-link">Privacy Policy</span>
// //             </Link>
// //           </div>
// //         </div>
// //       </div>
// //       {/* COPYRIGHT============== */}
// //       <div
// //         style={{
// //           textAlign: "center",
// //           borderTop: "1px solid #4E4949",
// //           fontSize: "1rem",
// //           color: "#4E4949",
// //           padding: "1.5rem",
// //         }}
// //       >
// //         © Copyright {new Date().getFullYear()}{" "}
// //         <Link to="/" style={{ fontWeight: "700", color: "#4E4949" }}>
// //           {" "}
// //           Bharat Batuk Private Limited{" "}
// //         </Link>
// //         All rights reserved.
// //       </div>
// //     </footer>
// //   );
// // }
